import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../services/supabase'

/**
 * Hook for newsletter subscription. Works for both:
 * - Anonymous users (calls subscribe-newsletter Edge Function)
 * - Logged-in users (uses useAdmin's subscribe which inserts via Supabase)
 * Use subscribeAnonymous for landing page when user is not logged in.
 */
export const useNewsletterSubscribe = () => {
  const queryClient = useQueryClient()

  const subscribeAnonymousMutation = useMutation({
    mutationFn: async (email: string) => {
      const { data, error } = await supabase.functions.invoke('subscribe-newsletter', {
        body: { email: email.trim() },
      })
      if (error) throw error
      if (data?.error) throw new Error(data.error)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscribers'] })
    },
  })

  return {
    subscribeAnonymous: subscribeAnonymousMutation.mutate,
    subscribeAnonymousAsync: subscribeAnonymousMutation.mutateAsync,
    subscribeAnonymousLoading: subscribeAnonymousMutation.isPending,
    subscribeAnonymousError: subscribeAnonymousMutation.error,
  }
}
